import * as React from "react";
import { useState } from "react";
import { Column } from "@origin-digital/ods-core";
import {
  FetchProjectsRequest,
  ProjectDropdownItem,
  SingleCompanyProjectsResonse,
} from "src/components/Projects/types";
import { apiClient } from "src/api/apiService";
import { mapProjectsToDropdownItems } from "src/components/Projects/helpers";
import { Autocomplete } from "@origin-digital/ods-lab";
import { RequestingCompany } from "../types";
import { IFormProps } from "../FormAccordionContainer";

interface IProjectNameProps extends IFormProps {
  requestingCompany: RequestingCompany | null;
  projectName: string;
  projectId: string;
}

const ProjectName = (props: IProjectNameProps) => {
  const { setFieldValue, requestingCompany, projectName, projectId } = props;
  const [projects, setProjects] = useState<ProjectDropdownItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  React.useEffect(() => {
    const fetchProjects = async ({ limit = 10 }: FetchProjectsRequest) => {
      setLoading(true);
      try {
        const response = await apiClient.get<SingleCompanyProjectsResonse>(
          `/project/${requestingCompany?.msaNumber}`,
          {
            params: { limit },
          }
        );
        setProjects(mapProjectsToDropdownItems(response.data.projects));
      } catch (err) {
        console.error("Failed to fetch projects:", err);
      } finally {
        setLoading(false);
      }
    };
    if (requestingCompany?.msaNumber) {
      fetchProjects({ limit: 10 });
    }
  }, [requestingCompany?.msaNumber]);
  return (
    <Column>
      <Autocomplete
        id="project-name"
        label="Project name"
        value={{ label: projectName, value: projectId }}
        //@ts-expect-error: need item callback
        onChange={(e, item, reason) => {
          if (reason === "clear") {
            setFieldValue("projectId", "");
            setFieldValue("projectName", "");
          } else {
            setFieldValue("projectId", item!.value);
            setFieldValue("projectName", item!.label);
          }
        }}
        loading={loading}
        textFieldProps={{
          variant: "outlined",
          hideHelperTextSpace: true,
        }}
        options={projects}
      />
    </Column>
  );
};

export default ProjectName;
